import { type Breakpoint, type Theme, useMediaQuery } from '@mui/material';

/**
 * True when the viewport is narrower than the given theme breakpoint.
 * Reserve it for behavior that CSS cannot express (e.g. opening a phone-only view);
 * layout changes belong to the design system components themselves.
 */
export function useBreakpointDown(breakpoint: Breakpoint) {
  return useMediaQuery(function isBelow(theme: Theme) {
    return theme.breakpoints.down(breakpoint);
  });
}
